import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { FeatureProvider } from "@/contexts/FeatureContext";
import { trackVisit } from "@/lib/anonTracker";
import ProtectedRoute from "@/components/ProtectedRoute";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import LibraryPage from "@/pages/LibraryPage";
import PlayerPage from "@/pages/PlayerPage";
import ProfilePage from "@/pages/ProfilePage";
import CategoryPage from "@/pages/CategoryPage";
import SubtitleEditorPage from "@/pages/SubtitleEditorPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import PricingPage from "@/pages/PricingPage";
import MagicAccessPage from "@/pages/MagicAccessPage";
import ConfidenceLandingPage from "@/pages/ConfidenceLandingPage";
import ConfidenceLibraryPage from "@/pages/ConfidenceLibraryPage";
import BillingSuccessPage from "@/pages/BillingSuccessPage";

function App() {
  useEffect(() => { trackVisit(); }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <FeatureProvider>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/confidence" element={<ConfidenceLandingPage />} />
          <Route path="/confidence/library" element={<ProtectedRoute><ConfidenceLibraryPage /></ProtectedRoute>} />
          <Route path="/billing/success" element={<ProtectedRoute><BillingSuccessPage /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/library" element={<ProtectedRoute><LibraryPage /></ProtectedRoute>} />
          <Route path="/library/:category" element={<ProtectedRoute><CategoryPage /></ProtectedRoute>} />
          <Route path="/player/:trackId" element={<ProtectedRoute><PlayerPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/subtitle-editor" element={<SubtitleEditorPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/access/:key" element={<AdminDashboardPage autoLogin />} />
          <Route path="/access/:key" element={<MagicAccessPage />} />
        </Routes>
        </FeatureProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
